import type { SVGProps } from 'react';
import * as React from 'react';

const SvgStepCurrent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="100%"
    viewBox="0 0 16 16"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M.75 8a7.25 7.25 0 1 1 14.5 0A7.25 7.25 0 0 1 .75 8" fill="#5C37EB" />
    <path
      d="M.75 8a7.25 7.25 0 1 1 14.5 0A7.25 7.25 0 0 1 .75 8Z"
      stroke="#5C37EB"
      strokeWidth={1.5}
    />
    <circle cx={8} cy={8} fill="#fff" r={4} />
  </svg>
);
export default SvgStepCurrent;
